module.exports = __webpack_public_path__ + "assets/fb69e239e6e79b0f449acc95f8b0b190.mp3";